import { GraphQLInputObjectType, GraphQLNonNull, GraphQLID } from 'graphql'
import { serverEnvironmentType } from './server'

type ServerEnvironment = 'DEVELOPMENT' | 'QA' | 'PRODUCTION'

export interface ServerChangeEnvironmentMutationArgs {
  readonly input?: {
    readonly organizationID: string
    readonly environment: ServerEnvironment
    readonly id: string
  }
}

export const serverChangeEnvironmentMutationArgs = {
  input: {
    type: new GraphQLInputObjectType({
      name: 'ServerChangeEnvironmentMutationArgs',
      description:
        'Mutation input type for deleting servers based on a set of filters.',
      fields: () => ({
        organizationID: {
          description:
            'The ID of the organization that owns the servers being mutated.',
          type: new GraphQLNonNull(GraphQLID)
        },
        id: {
          description: 'The ID of the server that is being mutated',
          type: new GraphQLNonNull(GraphQLID)
        },
        environment: {
          description:
            'The new environment to set for the server being mutated',
          type: new GraphQLNonNull(serverEnvironmentType)
        }
      })
    })
  }
}
